export default [
    "24 24",
    '<path d="M6 18L18 6M18 6H10M18 6V14" fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]

